module.exports = __webpack_public_path__ + "img/jamaica.41ab581b.svg";